import type { SecondLineResultCount } from '@risksmart-app/trpc/src/types';
import type { GetComplianceMonitoringAssessmentResultCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetComplianceMonitoringAssessmentResultCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetComplianceMonitoringAssessmentResultCount = createQueryHook<
  Record<string, never>,
  SecondLineResultCount,
  GetComplianceMonitoringAssessmentResultCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.complianceMonitoringAssessmentResultCount.queryOptions(),
  // Map each per-table count back onto its GraphQL aggregate root. ConnectedCount
  // sums the four; the factory surfaces undefined while loading, so genuine
  // zeros are preserved (no `?? 0` masking).
  mapTrpcDataToGraphQL: (data) => ({
    risk_controlled_second_line_result_aggregate: {
      aggregate: { count: data.risk_controlled_second_line_result },
    },
    risk_uncontrolled_second_line_result_aggregate: {
      aggregate: { count: data.risk_uncontrolled_second_line_result },
    },
    document_second_line_result_aggregate: {
      aggregate: { count: data.document_second_line_result },
    },
    obligation_second_line_result_aggregate: {
      aggregate: { count: data.obligation_second_line_result },
    },
  }),
  graphqlDocument: GetComplianceMonitoringAssessmentResultCountDocument,
});
